import { useState } from 'react'
import type { MenuItem } from '.'

type UseContextMenuResult<T> = {
  menuItems: MenuItem<T>[] | undefined
  updateMenu: (items: MenuItem<T>[]) => void
}

export const useContextMenu = <T>(initialItems: MenuItem<T>[] = []): UseContextMenuResult<T> => {
  const [menuItems, updateMenu] = useState<MenuItem<T>[] | undefined>(initialItems)

  return {
    menuItems,
    updateMenu,
  }
}
